module.exports = __webpack_public_path__ + "img/help_dataset_celltype2.9ecc3d51.png";